import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-history',
  templateUrl: './client-history.component.html',
  styleUrls: ['./client-history.component.css']
})
export class ClientHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
